import { createFeatureSelector, createSelector } from '@ngrx/store';
import { BankAccountFeatureName } from './bank-account.reducer';
import { BankAccount, BankAccountState } from './../../interfaces';

const getBankAccount = ({ data }: BankAccountState): BankAccount => data;

const getBankAccountLoaded = ({ loaded }: BankAccountState): boolean => loaded;

const getBankAccountName = ({ data }: BankAccountState): string => data.bankAccountName;

const getBankAccountType = ({ data }: BankAccountState): string => data.bankAccountType;

const getBankCity = ({ data }: BankAccountState): string => data.bankCity;

const getBankName = ({ data }: BankAccountState): string => data.bankName;

const getBankState = ({ data }: BankAccountState): string => data.bankState;

const getRoutingNumber = ({ data }: BankAccountState): string => data.routingNumber;

export const BankAccountFeatureSelector =
    createFeatureSelector<BankAccountState>(BankAccountFeatureName);

export const BankAccountSelector = createSelector(
    BankAccountFeatureSelector,
    getBankAccount
);

export const BankAccountLoadedSelector = createSelector(
    BankAccountFeatureSelector,
    getBankAccountLoaded
);

export const BankAccountNameSelector = createSelector(
    BankAccountFeatureSelector,
    getBankAccountName
);

export const BankAccountTypeSelector = createSelector(
    BankAccountFeatureSelector,
    getBankAccountType
);

export const BankCitySelector = createSelector(
    BankAccountFeatureSelector,
    getBankCity
);

export const BankNameSelector = createSelector(
    BankAccountFeatureSelector,
    getBankName
);

export const BankStateSelector = createSelector(
    BankAccountFeatureSelector,
    getBankState
);

export const RoutingNumberSelector = createSelector(
    BankAccountFeatureSelector,
    getRoutingNumber
);